export class Observance {
  date?: Date;
  fuites?: number;
  iahResiduel?: number;
  niveau?: number;
  periode?: number;
  pression?: number;
  p90_95?: number;
  seq?: number;
  obs?: number;

  constructor(
    date?: Date,
    fuites?: number,
    iahResiduel?: number,
    niveau?: number,
    periode?: number,
    pression?: number,
    p90_95?: number,
    seq?: number,
    obs?: number,
  ) {
    this.date = date;
    this.fuites = fuites;
    this.iahResiduel = iahResiduel;
    this.niveau = niveau;
    this.periode = periode;
    this.pression = pression;
    this.p90_95 = p90_95;
    this.seq = seq;
    this.obs = obs;
  }

  static factory(observanceAPI: ObservanceAPI): Observance {
    return new Observance(
      observanceAPI.Date ? new Date(observanceAPI.Date) : undefined,
      observanceAPI.Fuite,
      observanceAPI.IAH,
      observanceAPI.Niveau,
      observanceAPI.Periode,
      observanceAPI.Pression,
      observanceAPI.Pression95 ?? observanceAPI.Pression90,
      observanceAPI.Seq,
      observanceAPI.Utilisation ? observanceAPI.Utilisation / 60 : undefined,
    );
  }
}

export type ObservanceAPI = {
  Date?: string;
  Fuite?: number;
  IAH?: number;
  Niveau?: number;
  Periode?: number;
  Pression?: number;
  Pression90?: number;
  Pression95?: number;
  Seq?: number;
  Utilisation?: number;
};